module.exports = __webpack_public_path__ + "media/images/ansi-42dd24465c1ec460cb5e717033c15e86.png";